import { LinkedItem } from "./linkedItem";

export class Delegate {   
    
    scope!: number;
    assignments!: number[];
    delegateFrom!: string;
    delegateTo!: string[];
    startDate!:Date;
    endDate!:Date | null;
    linkedItems!:LinkedItem[];
}